import React, { useState } from "react";
import axios from "axios";
import { Form, Button, Modal } from "semantic-ui-react";

import { varieties } from "./helpers";

const UploadForm = ({
  buttonText,
  dealerId,
  documentId,
  onSuccess,
  variety,
}) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isOpen, setOpen] = useState(false);

  function onClose() {
    setOpen(false);
    setFile(null);
    setLoading(false);
    setError(null);
  }

  function onSubmitClick() {
    setLoading(true);
    setError(null);

    const req = new FormData();
    req.append("dealer_id", dealerId);
    req.append("file", file);
    req.append("variety", variety);

    if (documentId) {
      req.append("dealer_coi_id", documentId);
    }

    axios
      .post(`/images/dealer-coi/`, req)
      .then(() => {
        setLoading(false);
        onClose();
        onSuccess();
      })
      .catch((err) => {
        setLoading(false);
        setError(err.response.data.ui_message);

        setTimeout(() => {
          setError(null);
        }, 5000);
      });
  }

  const docName =
    variety !== null && varieties.find((f) => f.value === variety)
      ? varieties.find((f) => f.value === variety).text
      : "";

  return (
    <React.Fragment>
      <Button
        circular
        primary
        icon="upload"
        onClick={() => setOpen(true)}
        size="mini"
      />
      <Modal size="small" open={isOpen} onClose={onClose}>
        <Modal.Content>
          <Form>
            {variety !== null && (
              <React.Fragment>
                <Form.Input
                  type="file"
                  onChange={(e) => {
                    if (e.target.files && e.target.files.length) {
                      setFile(e.target.files[0]);
                    }
                  }}
                  label={docName ? `${docName} File` : "File"}
                />
              </React.Fragment>
            )}
          </Form>
          {error && (
            <p style={{ color: "red", marginTop: "1em", fontWeight: "bold" }}>
              {error}
            </p>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button basic content="Cancel" onClick={onClose} />
          <Button
            content="Submit"
            onClick={onSubmitClick}
            disabled={!file || variety === null}
            loading={loading}
            primary
            style={{ marginTop: "1em" }}
          />
        </Modal.Actions>
      </Modal>
    </React.Fragment>
  );
};

UploadForm.defaultProps = {
  buttonText: "Add Certificate of Insurance",
  documentId: null,
};

export default UploadForm;
